import { render, staticRenderFns } from "./SubPzList.vue?vue&type=template&id=5517d642&scoped=true&"
import script from "./SubPzList.vue?vue&type=script&lang=js&"
export * from "./SubPzList.vue?vue&type=script&lang=js&"
import style0 from "./SubPzList.vue?vue&type=style&index=0&id=5517d642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5517d642",
  null
  
)

export default component.exports